export const DISPUTES_CONFIGURE_SLICE_NAME = "disputesConfigure"
